module.exports = {
  'account.footer.copyright': '© 2018-2019 Binance.org 무단 전재와 복제를 금함.',
  'account.footer.copyright.trubi': '© 2018-2019 Trubi. 무단 전재와 복제를 금함.',
  'account.footer.exchange': '거래소',
  'account.footer.home': '홈',
  'balances.filteredByAsset': '자산으로 필터',
  'balances.hideZeroBalance': '없는 잔고 숨기기',
  'balances.myBalances': '내 잔고',
  'blocked.country.list':
    '미국, 알바니아, 보스니아 헤르체고비나, 벨로루시, 콩고 (DRC), 코트디부아르, 크림, 쿠바, 이라크, 이란, 북한, 라이베리아, 마케도니아, 미얀마, 세르비아, 수단, 시리아, 짐바브웨.',
  'common.cancel': '취소',
  'common.close': '종료',
  'common.confirm': '확인 ',
  'common.connect': '연결',
  'common.continue': '계속',
  'common.errorOccured': '오류 발생',
  'common.goBack': '뒤로가기',
  'common.googleUnlock': '구글 드라이브',
  'common.keystoreFile': '키스토어 파일',
  'common.ledgerDevice': '렛저 디바이스',
  'common.loading': '로딩중',
  'common.mnemonicPhrase': '복구 문구',
  'common.networkError': '네트워크 오류',
  'common.or': '또는',
  'common.password': '비밀번호',
  'common.placeOrder': '주문하기',
  'common.pleaseCheckVisitWebsite': '아래 주소에 방문하신게 맞는지 확인하십시오 ',
  'common.previous': '이전',
  'common.privateKey': '프라이빗 키',
  'common.systemError': '시스템 오류',
  'common.trezorDevice': '트레저 디바이스',
  'common.viewMyPrivateKey': '내 프라이빗 키 보기',
  'common.viewOnly': '보기 전용',
  'common.walletConnect': '모바일 지갑',
  'common.yes': '예',
  'common.warning': 'Warning',
  'create.backupKeystore.backupYour': '백업하기 ',
  'create.backupKeystore.cannotRecoveredIt': '잃어버리면 복구할 수 없습니다.',
  'create.backupKeystore.createBackupFile': '이 파일의 백업을 만드십시오!',
  'create.backupKeystore.downloadKeystoreFile': '키스토어 파일 다운로드 (UTC/JSON)',
  'create.backupKeystore.getMyPrivateKey': '내 프라이빗 키 받기',
  'create.backupKeystore.keystoreFile': '키스토어 파일',
  'create.backupKeystore.needFirstDownload': '키스토어 파일을 먼저 다운로드해야 합니다',
  'create.backupKeystore.notShareFile':
    '확인되지 않은 웹사이트에서 이 파일을 공유하거나 사용하지 마십시오. 자금을 도난당할 수 있습니다.',
  'create.backupMnemonic.note': '아래의 텍스트를 종이에 백업하고 안전한 곳에 보관하십시오.',
  'create.backupMnemonic.title': '니모닉을 백업하십시오',
  'create.backupText': '아래의 텍스트를 종이에 백업하고 안전한 곳에 보관하십시오.',
  'create.chooseKSOrMnemonic.keystoreAndPassword': '키스토어 파일 + 비밀번호',
  'create.chooseKSOrMnemonic.keystoreFile': '키스토어 파일',
  'create.chooseKSOrMnemonic.recommendedUSBDrive': 'USB 드라이브에 백업할 것을 권장합니다',
  'create.chooseKSOrMnemonic.recommendedUSBDriveOrPaper':
    '종이 또는 USB 드라이브에 백업할 것을 권장합니다',
  'create.chooseKSOrMnemonic.title': '새로운 지갑을 어떻게 만드시겠습니까?',
  'create.chooseKSOrMnemonic.unlockExistWallet': '기존 지갑 잠금 해제',
  'create.chooseKSOrMnemonic.useKeystoreFile':
    '키스토어 파일 (UTC / JSON) + 비밀번호를 사용하여 지갑에 접근',
  'create.chooseKSOrMnemonic.useMnemonicPhrase': '24 단어 니모닉 문구를 사용하여 지갑에 접근',
  'create.confirmNote': '니모닉 문구를 적어놓으셨습니까?',
  'create.createNewWallet': '새로운 지갑 생성',
  'create.doubleConfirmMnemonic.note':
    '적어놓은 문구가 올바른지 확인하기 위해 니모닉 문구를 올바른 순서로 선택하십시오.',
  'create.doubleConfirmMnemonic.title': '보조 접근 방법 선택',
  'create.doubleConfirmMnemonic.tryAgain': '니모닉 문구 순서가 잘못되었습니다. 다시 시도하십시오.',
  'create.downloadKeyStoreFile': '키스토어 파일 다운로드',
  'create.enterPassword': '비밀번호 입력',
  'create.google.createWallet': '지갑 생성',
  'create.google.createdSuccessfully': '지갑 생성 성공',
  'create.google.creationFailure': '지갑 생성 실패',
  'create.google.tryAgain': '다시 시도하기',
  'create.google.walletName': '지갑 이름',
  'create.googledrive.rePassErr': '입력한 비밀번호가 일치하지 않습니다',
  'create.keystoreFileAndPassword': '키스토어 파일 + 비밀번호 생성',
  'create.pick.useGoogleDrive.description': '구글 계정을사용하여 새로운 지갑 생성',
  'create.pick.useGoogleDrive.title': '구글 드라이브 사용',
  'create.pick.useLocalKeystore.description': '디바이스에 저장할 수 있는 새로운 지갑을 생성',
  'create.pick.useLocalKeystore.title': '키스토어 파일 사용',
  'create.pleaseCheck': '아래 주소에 방문하신게 맞는지 확인하십시오 ',
  'create.reEnterPassword': '비밀번호 재입력',
  'create.stepTwo.desc':
    '니모닉 문구를 표시하려고 합니다, 다른 사람이 화면을 보고 있지 않은지 확인하십시오.',
  'create.success.desc1': '바이낸스 체인 지갑을 사용할 준비가 되었습니다.',
  'create.success.desc2': '탈중앙화된 거래소!',
  'create.success.title': '모두 준비되었습니다!',
  'create.success.unlockWallet': '지갑 해제',
  'create.tutorial.next': '다음',
  'create.tutorial.skip': '튜토리얼 건너뛰기 (권장하지 않음)',
  'create.tutorial.step1.desc1':
    '바이낸스는 바이낸스 체인에서 가장 안전하고 최상의 경험을 제공하기 위해 최선을 다하고 있습니다. 이를 위해 우리는 귀하에게 탈중앙화된 지갑이 어떻게 작동하는지 이해하고 자신을 보호하기 위한 조치를 취할 수 있는 잠깐의 시간을 요청합니다. 전체 서비스 약관은 여기에서 찾을 수 있습니다.',
  'create.tutorial.step1.title': '우리의 약속',
  'create.tutorial.step2.desc1':
    '귀하의 자금을 관리하는 것에 대한 책임은 전적으로 귀하에게 있습니다. 바이낸스조차도 귀하가 지갑을 잃어버리면 지갑을 복구하는데 도움을 줄 수 없습니다.',
  'create.tutorial.step2.desc2':
    '바이낸스에서 지갑을 만들면 3가지 서로 다른 형식이 제공되며 각 형식을 사용하여 지갑에 접근할 수 있습니다.',
  'create.tutorial.step2.title': '자금 관리',
  'create.tutorial.step3.desc1':
    '키스토어 파일을 "사용자 ID"와 같이 생각하면 되며 비밀번호로 지갑을 해제할 수 있습니다. 지갑에 접근하기 위해서는 둘 다 필요하기 때문에 안전하게 보관하십시오. 이는 바이낸스에서 필요한 형식입니다.',
  'create.tutorial.step3.title': '키스토어 파일 + 비밀번호',
  'create.tutorial.step4.desc1':
    '24개의 단어가 "사용자 ID"이자 비밀번호입니다. 키스토어 파일 또는 비밀번호를 잃어버릴 경우 지갑에 접근할 수 있는 보조 방법입니다. 니모닉 문구를 아는 사람은 누구나 지갑에 접근할 수 있으므로 안전하게 보관하십시오.',
  'create.tutorial.step4.title': '니모닉 문구',
  'create.tutorial.step5.desc1': '이것은 니모닉 문구 단어의 대체 표현입니다.',
  'create.tutorial.step5.desc2':
    '바이낸스는 모든 사용자가 키스토어 파일 + 비밀번호를 사용하도록 하며 니모닉 문구 또는 프라이빗 키 중에서 보조 방법을 선택할 수 있도록 합니다.',
  'create.tutorial.step5.title': '프라이빗 키',
  'create.tutorial.title': '지갑 생성 튜토리얼',
  'create.tutorial.understand': '이해했습니다.',
  'create.understandCheckbox':
    '바이낸스가 비밀번호 또는 키스토어 파일을 복구하거나 재설정할 수 없음을 이해합니다. 키스토어 파일/비밀번호를 직접 백업하고 비밀을 유지하고 모든 지갑 생성 과정을 완료할 것이며 모든 것에 동의합니다 ',
  'create.understandCheckbox.terms': '이용 약관',
  'create.unlockExistWallet': '기존 지갑 잠금 해제',
  'create.yourKeyStore': '키스토어',
  'editWallet.remove': '삭제',
  'editWallet.remove.desc1': '지갑에 돈이 없는지 확인하십시오',
  'editWallet.remove.desc2': '지갑을 복구할 방법이 없습니다',
  'editWallet.remove.removeButton': '예, 지갑을 삭제해주십시오',
  'editWallet.remove.title': '이 지갑을 정말로 삭제하시겠습니까?',
  'editWallet.rename': '이름 바꾸기',
  'editWallet.rename.duplicateName': '지갑 이름이 존재합니다',
  'editWallet.rename.errMsg': '이름은 빈칸이 아니어야합니다',
  'editWallet.rename.title': '지갑 이름',
  'editWallet.title': '지갑 이름',
  'editWallet.createWallet': '지갑 생성',
  'editWallet.unlockWallet': '지갑 해제',
  'exchange.BTCValue': 'BTC 가치',
  'exchange.amount': '금액',
  'exchange.asset': '자산',
  'exchange.availableBalance': '사용 가능 잔고',
  'exchange.blockHeight': '블록높이',
  'exchange.buy': '매수',
  'exchange.calendar.clear': '삭제',
  'exchange.calendar.ok': '확인',
  'exchange.calendar.today': '오늘',
  'exchange.chartbox.depth': '깊이',
  'exchange.coin': '코인',
  'exchange.date': '날짜',
  'exchange.estimatedValue': '예상 가치',
  'exchange.filled': '체결',
  'exchange.from': '~에서',
  'exchange.frozen': '동결',
  'exchange.hideAllCanceled': '취소된 모든 항목 숨기기',
  'exchange.hideOtherPairs': '다른 페어 숨기기',
  'exchange.inOrder': '거래중',
  'exchange.index.books': '북',
  'exchange.index.chart': '차트',
  'exchange.max': '최대',
  'exchange.min': '최소 거래 단위:',
  'exchange.name': '이름',
  'exchange.notional': '계약',
  'exchange.oneDay': '1일',
  'exchange.oneMonth': '1달',
  'exchange.oneWeek': '1주',
  'exchange.pair': '페어',
  'exchange.placeOrder.bestAsk': '최고 매수가',
  'exchange.placeOrder.bestBid': '최고 매도가',
  'exchange.placeOrder.limitOrder': '지정가 주문',
  'exchange.placeOrder.noEnoughBalance': '잔고가 부족합니다',
  'exchange.placeOrder.orderError': '주문 오류',
  'exchange.placeOrder.orderPriceHigher':
    '주문 가격이 마지막 가격보다 2% 이상 높습니다. 신중하게 진행하십시오.',
  'exchange.placeOrder.orderPriceLow':
    '주문 가격이 마지막 가격보다 2% 이상 낮습니다. 신중하게 진행하십시오.',
  'exchange.placeOrder.pleaseInputCorrectAmount': '정확한 금액을 입력하십시오',
  'exchange.placeOrder.pleaseInputCorrectPrice': '정확한 가격을 입력하십시오',
  'exchange.placeOrder.roundSizeErrorMsg': '{lotSize} 의 배수로 {side}{baseAsset} 만 가능합니다',
  'exchange.placeOrder.successNotifyMsg':
    '{side}{quantity}{quoteAsset} 에 대한 지정가 주문을 성공적으로 생성했습니다.',
  'exchange.placeOrder.successNotifyTitle': '지정가 {side} 주문 생성',
  'exchange.pleaseSelectDate': '날짜를 선택하십시오',
  'exchange.pleaseUnlockWallet.btn': '지갑 해제',
  'exchange.pleaseUnlockWallet.createNewWallet': '새로운 지갑 생성',
  'exchange.pleaseUnlockWallet.desc': '죄송합니다! 먼저 지갑을 잠금 해제하십시오',
  'exchange.pleaseUnlockWallet.noWallet': '지갑이 없나요?',
  'exchange.price': '가격',
  'exchange.search': '검색',
  'exchange.sell': '매도',
  'exchange.side': '사이드',
  'exchange.status': '상태',
  'exchange.symbolPriceInfo.high': '고가',
  'exchange.symbolPriceInfo.lastPrice': '마지막 체결가',
  'exchange.symbolPriceInfo.low': '저가',
  'exchange.symbolPriceInfo.twentyFourHChange': '전일대비',
  'exchange.symbolPriceInfo.twentyFourHHigh': '24h 고가',
  'exchange.symbolPriceInfo.twentyFourHLow': '24h 저가',
  'exchange.symbolPriceInfo.twentyFourHVolume': '24h 거래량',
  'exchange.symbolPriceInfo.vol': '거래량',
  'exchange.threeMonths': '3달',
  'exchange.time.from': '~에서',
  'exchange.to': '~으로',
  'exchange.total': '총액',
  'exchange.totalBalance': '총 잔고',
  'exchange.tradingHistory.time': '시간',
  'exchange.tradingHistory.title': '거래 내역',
  'exchange.tradingPair.change': '변동',
  'exchange.tradingPair.pair': '페어',
  'exchange.tradingPair.price': '가격',
  'exchange.tradingPair.search': '검색',
  'exchange.tradingPair.volume': '거래량',
  'exchange.txFee': 'Tx수수료',
  'exchange.txHash': 'Tx해시',
  'exchange.type': '유형',
  'exchange.value': '가치',
  'fees.fee': '수수료',
  'fees.height': '단계',
  'fees.note': '비고',
  'footer.terms': '이용 약관',
  'footer.privacy': 'Privacy',
  'googledrive.create.nameExist': '존재하는 이름',
  'header.balances': '잔고',
  'header.createWallet': '새로운 지갑 생성',
  'header.exchange': '거래소',
  'header.explorer': '탐색기',
  'header.faq': '문서 / FAQ',
  'header.feeHistory': '수수료 내역',
  'header.forums': '포럼',
  'header.mainnet': '메인넷',
  'header.openOrders': '대기 주문',
  'header.orderHistory': '주문 내역',
  'header.orders': '주문',
  'header.testnet': '테스트넷',
  'header.tradeHistory': '거래 내역',
  'header.transactions': '트랜잭션',
  'header.unlockWallet': '지갑 해제',
  'header.user.changeWallet': '지갑 변경',
  'header.user.closeWallet': '지갑 종료',
  'header.user.coinomi': '코이노미 ',
  'header.user.copyAddress': '주소 복사',
  'header.user.copySuccess': '복사 성공!',
  'header.user.createNewWallet': '새로운 지갑 생성',
  'header.user.exportKeystoreFile': '키스토어 파일 내보내기',
  'header.user.goToExplorer': '탐색기로 이동',
  'header.user.infinito': '인피니토 ',
  'header.user.ledger': '렛저 ',
  'header.user.trezor': '트레저 디바이스',
  'header.user.wallet': '지갑',
  'header.user.walletConnect': '월렛커넥트 ',
  'header.youWantCloseWallet': '지갑을 종료하시겠습니까?',
  'home.aboutPage.desc1.line1': '바이낸스 체인은 바이낸스가 처음 개발한 블록체인입니다.',
  'home.aboutPage.desc1.line2':
    '최신이고 안전하며 즉각적인 트랜잭션 최종성을 가지고 있습니다 (빠릅니다).',
  'home.aboutPage.desc2.line1': '바이낸스 DEX는 탈중앙화된 주문 매칭 엔진이고,',
  'home.aboutPage.desc2.line2': '핵심 바이낸스 체인 기술로 작동합니다.',
  'home.aboutPage.desc3.line1': '바이낸스 DEX는 발행을 위한 안전한 최신식 마켓플레이스입니다',
  'home.aboutPage.desc3.line2':
    '디지털 자산을 교환할 수 있으며 본인이 아닌 다른 사람이 키를 가지고 있지 않습니다. 좋아하는 자산을 매우 안전하게 거래하십시오.',
  'home.aboutPage.title': '바이낸스 DEX 정보',
  'home.binanceDex': '바이낸스 DEX',
  'home.processPage.aboutBalance': '바이낸스 DEX 정보',
  'home.processPage.create': '생성',
  'home.processPage.createDesc': '첫 단계는 바이낸스 체인 주소를 생성하는 것입니다.',
  'home.processPage.createWallet': '새로운 지갑 생성',
  'home.processPage.getStart': '바이낸스 DEX 시작하기',
  'home.processPage.go': '시작',
  'home.processPage.placeOrders': '주문 제출',
  'home.processPage.placeOrdersDesc': '웹 지갑 또는 API를 사용하여 주문을 전송하고 취소하십시오.',
  'home.processPage.transferAssets': '자산 전송',
  'home.processPage.transferAssetsDesc':
    '바이낸스 체인을 지원하는 지갑으로 생성할 수 있는 바이낸스 체인 주소를 사용하면 해당 주소에 보관중인 BNB 또는 다른 자산을 전송할 수 있습니다.',
  'home.processPage.unlock': '잠금 해제',
  'home.processPage.unlockDesc': '지갑을 잠금 해제할수 있는 4가지 방법',
  'home.processPage.unlockMode1': '월렛커넥트',
  'home.processPage.unlockMode2': '렛저',
  'home.processPage.unlockMode3': '키스토어 파일 + 비밀번호',
  'home.processPage.unlockMode4': '니모닉',
  'home.processPage.unlockWallet': '지갑 해제',
  'home.startPage.createWallet': '지갑 생성',
  'home.startPage.desc1': '빠르고 안전한 탈중앙 디지털 자산 거래소',
  'home.startPage.desc2': '새로운 암호화폐 거래 표준이 여기 있습니다.',
  'home.startPage.getTestBNB': '테스트 BNB 받기',
  'home.startPage.startTrading': '거래 시작하기',
  'home.whyPage.community': '이것은 커뮤니티 이니셔티브입니다',
  'home.whyPage.communityDesc':
    '바이낸스 DEX는 온체인 거버넌스 및 오픈 소스 소프트웨어 구성 요소로 작동합니다.',
  'home.whyPage.decentralized': '탈중앙',
  'home.whyPage.decentralizedDesc':
    '제3자 또는 중앙화된 기관 없이 직접 지갑대 지갑 거래를 경험하십시오.',
  'home.whyPage.getStarted': '시작하기',
  'home.whyPage.lowTradingFees': '낮은 거래 수수료',
  'home.whyPage.lowTradingFeesDesc':
    '출금, 입금, 주문 입력 수수료 없이 거래하십시오 — BNB 홀더는 더 많은 혜택을 누릴 수 있습니다.',
  'home.whyPage.safeAndSecure': '안전하고 확실한',
  'home.whyPage.safeAndSecureDesc':
    '귀하의 자금은 귀하만 제어할 수 있는 프라이빗 키를 사용하는 블록체인 주소에 보관됩니다.',
  'home.whyPage.title': '왜 바이낸스 DEX입니까',
  'home.whyPage.userFriendly': '사용자 친화적인',
  'home.whyPage.userFriendlyDesc':
    '지갑을 생성하고, 잠금 해제하면 거래 준비가 완료됩니다. 입금 또는 출금할 필요가 없습니다.',
  'inputPassword.passwordRule': '비밀번호는 다음 속성을 포함해야 합니다',
  'inputPassword.passwordRule1': '8자 이상',
  'inputPassword.passwordRule2': '대문자, 기호 및 숫자',
  'inputPassword.setANewPassword': '새로운 비밀번호 설정',
  'landing.connectWallet': '지갑 연결',
  'landing.createWallet': '지갑 생성',
  'landing.desc1': '바이낸스 DEX',
  'landing.desc2':
    '빠르고 안전한 탈중앙 디지털 자산 거래소. 새로운 암호화폐 거래 표준이 여기 있습니다.',
  'landing.footer.fee': '수수료',
  'landing.footer.terms': '이용 약관',
  'landing.footer.privacy': 'Privacy',
  'landing.how.connect': '연결',
  'landing.how.connect.desc':
    '바이낸스 DEX에 접근하는 것은 생각보다 쉽습니다. 연결 버튼을 클릭하고 연결 옵션 중에 선택하십시오. 모든 준비가 끝났습니다.',
  'landing.how.create': '생성',
  'landing.how.create.desc':
    '바이낸스 DEX를 사용하면 편리한 키스토어에서 매우 안전한 하드웨어 지갑 옵션에 이르기까지 자유롭게 선택할 수 있습니다.',
  'landing.how.step': '단계',
  'landing.how.title': '사용 방법',
  'landing.how.trade': '거래',
  'landing.how.trade.desc':
    '우리의 목표는 Binance.com과 비교하여 완벽하고 구별할 수 없게 거래할 수 있도록 하는 것입니다. 이를 위해 우리는 귀하가 좋아하는 모든 것이 바이낸스 DEX에도 있도록 최고의 기능을 최적화했습니다.',
  'landing.markets': '마켓',
  'landing.markets.24HChange': '전일대비',
  'landing.markets.24HVolume': '24H 거래량',
  'landing.markets.lastPrice': '마지막 체결가',
  'landing.markets.pair': '페어',
  'landing.markets.searchPlaceholder': '코인 이름 검색',
  'landing.menu.balances': '잔고',
  'landing.menu.changeWallet': '지갑 변경',
  'landing.menu.closeWallet': '지갑 종료',
  'landing.menu.community': '커뮤니티',
  'landing.menu.copyAddress': '주소 복사',
  'landing.menu.docs': '문서',
  'landing.menu.exchange': '거래소',
  'landing.menu.explorer': '탐색기',
  'landing.menu.orders': '주문',
  'landing.menu.orders.feeHistory': '수수료 내역',
  'landing.menu.orders.openOrders': '대기 주문',
  'landing.menu.orders.orderHistory': '주문 내역',
  'landing.menu.orders.tradeHistory': '거래 내역',
  'landing.menu.testnet': '테스트넷',
  'landing.menu.tools': '도구',
  'landing.menu.transaction': '트랜잭션',
  'landing.menu.wallet': '지갑',
  'landing.startTrading': '거래 시작하기',
  'landing.trust.activeAddress': '활성화된 지갑',
  'landing.trust.activeAddress.desc':
    '더 많은 사람들이 다른 지갑 솔루션보다 바이낸스 DEX의 인프라와 거래 시스템을 신뢰합니다.',
  'landing.trust.pairs': '페어',
  'landing.trust.pairs.desc':
    '바이낸스 DEX는 매주 추가되는 옵션과 함께 거래에 유연성을 제공합니다.',
  'landing.trust.rank': '순위권',
  'landing.trust.rank.desc':
    '바이낸스 DEX는 코인마켓캡에서 거래량 기준으로 1위를 차지한 탈중앙화 암호화폐 거래소입니다.',
  'landing.trust.title': '사람들이 우리를 신뢰하는 이유',
  'landing.why.competitive': '경쟁력 있는',
  'landing.why.competitive.desc':
    'BNB를 사용하여 거래 수수료를 지불하면 수수료는 0.04%에 불과합니다. 이는 세계 최고의 거래소 Binance.com 거래 수수료의 거의 절반입니다.',
  'landing.why.fast': '빠른',
  'landing.why.fast.desc':
    '1초의 블록 시간으로 블록체인 거래 확인은 이미 지나간 일입니다. 단점 없이 DEX의 모든 이점을 누리십시오.',
  'landing.why.secure': '안전한',
  'landing.why.secure.desc':
    '바이낸스 DEX는 새로운 차원의 보안을 제공합니다. P2P 전송 및 거래로 보안 위협에 거의 노출되지 않습니다.',
  'landing.why.title': '왜 바이낸스 DEX입니까',
  'lang.menu.copyAddress': ' ',
  'noContent.descPrefix': '귀하는 없습니다 ',
  'openOrders.areYourTrue': '정말로 하시겠습니까',
  'openOrders.cancel': '취소',
  'openOrders.cancel all': '전부 취소',
  'openOrders.cancel buy': '매수 취소',
  'openOrders.cancel sell': '매도 취소',
  'openOrders.cancelAll': '전부 취소',
  'openOrders.cancelBuy': '매수 취소',
  'openOrders.cancelOrder': '주문 취소',
  'openOrders.cancelOrders': '주문 취소',
  'openOrders.cancelPartialSuccess': '부분 취소 성공',
  'openOrders.cancelSell': '매도 취소',
  'openOrders.cancelSuccess': '취소 성공',
  'openOrders.keepOrder': '주문 유지',
  'openOrders.keepOrders': '주문 유지',
  'openOrders.noBuyOpenOrders': '대기 매수 주문 없음',
  'openOrders.noOpenOrders': '대기 주문 없음',
  'openOrders.noSellOpenOrders': '대기 매도 주문 없음',
  'openOrders.title': '대기 주문',
  'orderForm.amount': '금액',
  'orderForm.avb': 'Avb',
  'orderForm.buy': '매수',
  'orderForm.equivalent': '등가',
  'orderForm.price': '가격',
  'orderForm.sell': '매도',
  'orderForm.total': '합계',
  'orderHistory.openHistory': '주문 내역',
  'orderHistory.title': '주문 내역',
  'orderHistory.tradeId': '거래 ID',
  'orderHistory.tradingPrice': '거래 가격',
  'orderHistory.tradingTotal': '거래 총합',
  'privateKeyModal.backupText': '아래의 텍스트를 종이에 백업하고 안전한 곳에 보관하십시오.',
  'privateKeyModal.title': '귀하의 프라이빗 키',
  'testnet.binanceChainExplorerGuide': '바이낸스 체인 탐색기 가이드',
  'testnet.fastAndSecureDesc': '빠르고 안전한 탈중앙 디지털 자산 거래소',
  'testnet.fundingYourTestnetAccount': '테스트넷 계정에 자금 제공',
  'testnet.howToAccessYourWallet': '지갑에 접근하는 방법',
  'testnet.howToCreateAWallet': '지갑을 생성하는 방법',
  'testnet.interfaceGuide': '인터페이스 가이드',
  'testnet.thingsToAvoid': '피해야 할 사항들',
  'testnet.title': '바이낸스 탈중앙 거래소 (테스트넷)',
  'token.issueModal.mintable': '민트 가능한',
  'token.issueModal.name': '토큰 이름',
  'token.issueModal.nameErrMsg': '토큰 이름은 32자로 제한됩니다',
  'token.issueModal.symbol': '기호',
  'token.issueModal.symbolErrMsg': '기호는 영숫자여야하며 길이는 3~8자로 제한됩니다',
  'token.issueModal.title': '토큰 발행',
  'token.issueModal.totalSupply': '총 공급량',
  'token.issueModal.totalSupplyErrMsg': '유효하지 않은 공급량',
  'token.listModal.address': '주소',
  'token.listModal.confirm': '확인',
  'token.listModal.initPrice': '초기 가격',
  'token.listModal.proposalId': '제안서 ID',
  'token.listModal.quoteAsset': '자산 견적',
  'token.listModal.title': '토큰 상장',
  'token.listModal.tokenName': '토큰 이름',
  'token.main.burn': '소각',
  'token.main.freeze': '동결',
  'token.main.issueToken': '토큰 발행',
  'token.main.list': '상장',
  'token.main.listSuccessmsg': '상장 성공',
  'token.main.mint': '민트',
  'token.main.proposal': '제안서',
  'token.main.submitListFirst': '상장 제안서를 먼저 제출하십시오',
  'token.main.submitSuccessmsg': '상장 제안서 제출 성공',
  'token.main.title': '내 토큰 목록',
  'token.main.unfreeze': '동결 해제',
  'token.proposalModal.address': '주소',
  'token.proposalModal.baseAsset': '기본 자산',
  'token.proposalModal.desc': '설명',
  'token.proposalModal.expireTime': '만료 시간',
  'token.proposalModal.hours': '시간',
  'token.proposalModal.initDeposit': '초기 입금',
  'token.proposalModal.initPrice': '초기 가격',
  'token.proposalModal.initPriceErr': '초기 가격은 비어있으면 안됩니다',
  'token.proposalModal.initPriceErr2': '초기 가격은 0보다 커야합니다',
  'token.proposalModal.quoteAsset': '자산 견적',
  'token.proposalModal.title': '상장 제안서',
  'token.proposalModal.titleErr': '제안서 제목은 비어있으면 안됩니다',
  'token.proposalModal.titleErr2': '제안서 제목이 최대 길이인 128보다 깁니다',
  'token.proposalModal.votingPeriod': '투표 기간',
  'token.table.col.mintable': '민트 가능한',
  'token.table.col.name': '이름',
  'token.table.col.symbol': '기호',
  'token.table.col.totalSupply': '총 공급량',
  'token.tokenModal.address': '주소',
  'token.tokenModal.amount': '금액',
  'token.tokenModal.available': '사용 가능',
  'token.tokenModal.burnTitle': '토큰 소각',
  'token.tokenModal.confirm': '확인',
  'token.tokenModal.desc': ' ',
  'token.tokenModal.freezeTitle': '토큰 동결',
  'token.tokenModal.mintTitle': '토큰 민트',
  'token.tokenModal.name': '이름',
  'token.tokenModal.unfreezeTitle': '토큰 동결 해제',
  'token.warning':
    'We do not support walletconnect compatible wallets currently and for security reason, Ledger is the best choice to Issue/List/Mint/Burn Token',
  'tradeHistory.tradeHistory': '거래 내역',
  'transaction.here': '이곳',
  'transaction.notes': '모든 거래가 아래에 포함되어 있는 것은 아닙니다. 전체 내역은 참조하십시오',
  'txHistory.here': '이곳',
  'txHistory.notEveryTransactionIsIncludedBelow':
    '모든 거래가 아래에 포함되어 있는 것은 아닙니다. 전체 내역은 이곳을 참조하십시오.',
  'txHistory.title': '거래 내역',
  'unlock.connectAddress.enterYourAddress': '주소를 입력하십시오',
  'unlock.connectAddress.invalidAddress': '유효하지 않은 주소',
  'unlock.connectAddress.viewOnlyMode': '보기 전용 모드로 주소를 입력하십시오',
  'unlock.createNewWallet': '새로운 지갑 생성',
  'unlock.google.chooseWallet': '사용 가능한 지갑 중에서 선택하십시오:',
  'unlock.google.logIn': '로그인',
  'unlock.google.notLoggedIn': '구글 계정에 로그인하지 않았습니다',
  'unlock.google.signedInAs': '로그인 되었습니다',
  'unlock.googledrive.editWallet': '지갑 정보 수정',
  'unlock.googledrive.wallets': '계속하려면 다음 지갑 중에서 선택하십시오:',
  'unlock.index.selectUnlockType': '잠금 해제 방법을 선택하십시오',
  'unlock.index.title': '지갑 해제',
  'unlock.keystore.enterYourWalletPass': '지갑 비밀번호를 입력하십시오',
  'unlock.keystore.paste': '또는 키스토어 파일의 내용을 붙여 넣으십시오',
  'unlock.keystore.select': '암호화된 지갑 파일을 연결하고 비밀번호를 입력하십시오',
  'unlock.keystore.upload': '키스토어 파일 업로드',
  'unlock.ledger.appInstallation': '앱 설치',
  'unlock.ledger.binanceChainReady': '바이낸스 체인 준비',
  'unlock.ledger.connectToLedger': '렛저에 연결',
  'unlock.ledger.enterPINCode': 'PIN 코드 입력',
  'unlock.ledger.getTheApp': '앱 받기',
  'unlock.ledger.havingConnectionIssues': '연결 문제가 있으십니까?',
  'unlock.ledger.mustBeOnScreen': '화면에 있어야 합니다',
  'unlock.ledger.openBinanceChain': '바이낸스 체인 열기',
  'unlock.ledger.text': '화면의 지시에 따라 여기에 하드웨어 지갑을 연결하십시오',
  'unlock.ledger.title': '렛저 디바이스로 잠금 해제',
  'unlock.ledger.usageInstructions': '사용 지침',
  'unlock.mnemonic.pleaseEnterYourPhrase': '24개 단어 문구를 입력하십시오',
  'unlock.mnemonic.pleaseSeparateEachWordSpace': '각 단어를 공백으로 분리하십시오.',
  'unlock.mnemonic.warning.desc1': '이 옵션은 손실된 키스토어 파일 또는 비밀번호를 복원하며,',
  'unlock.mnemonic.warning.desc2': '다른 월렛 앱에서 시드를 가져옵니다.',
  'unlock.mnemonic.warning.desc3':
    '경고! 아무 웹사이트에 시드 문구 또는 프라이빗 키를 입력하는 것은 매우 위험합니다. 브라우저에 악성 확장 프로그램이 설치되어 있거나 실수로 피싱 웹사이트에 방문하면 자산을 도난 당할 수 있습니다.',
  'unlock.privateKey.enterYourPrivateKey': '프라이빗 키를 입력하십시오 (16진수 형식)',
  'unlock.privateKey.invalid':
    '입력한 프라이빗 키가 올바른 형식이 아니며 유효하지 않습니다. 다시 시도해주십시오.',
  'unlock.privateKey.passwordInvalid': '해당 비밀번호가 유효하지 않습니다. 다시 시도해주십시오.',
  'unlock.privateKey.warning': '손실된 키스토어 파일 또는 비밀번호를 복원',
  'unlock.privateKey.warningQuestion':
    '아무 웹사이트에 프라이빗 키를 입력하는 것은 매우 위험합니다. 브라우저에 악성 확장 프로그램이 설치되어 있거나 실수로 피싱 웹사이트에 방문하면 자산을 도난 당할 수 있습니다.',
  'unlock.recover.content': '지갑 생성 중에 안내 받은 복구 문구를 사용하여 지갑 접근 복구',
  'unlock.recover.download.button': '다운로드',
  'unlock.recover.downloadTitle': '키스토어 파일 다운로드',
  'unlock.recover.password.placeholder': '강력한 비밀번호를 입력하십시오',
  'unlock.recover.submit': '확인',
  'unlock.recover.title': '키스토어 파일 복원',
  'unlock.recover.understand.continue': '키스토어 파일 복원',
  'unlock.recover.word.placeholder': '검색',
  'unlock.recover.wordlist.reset': '초기화',
  'unlock.recover.wordlistTitle': '왼쪽 목록에서 니모닉 문구를 선택하십시오',
  'unlock.support.wallets': ' ',
  'unlock.temporarySessionPassword': '임시 세션 비밀번호',
  'unlock.thisIsNotAValidWalletFile': '유효한 지갑 파일이 아닙니다',
  'unlock.trezor.connectToTrezor': '트레저에 연결',
  'unlock.trezor.firmwareNotice':
    '참고: 바이낸스 체인을 디바이스에서 사용하기 위해 트레저 펌웨어를 최신 버전으로 업데이트했는지 확인하십시오.',
  'unlock.trezor.notOnTestNet': '비고: 트레저 디바이스는 현재 크롬 또는 파이어폭스가 필요합니다 ',
  'unlock.trezor.title': '트레저 디바이스로 잠금 해제',
  'unlock.unlockWalletNow': '지금 지갑 해제',
  'unlock.walletConnect.notes':
    '참고: 트러스트 월렛 및 쿨월렛은 바이낸스 체인 테스트넷을 지원하지 않습니다.',
  'unlock.walletConnect.recommendedWallet': '지원되는 앱은 다음과 같습니다',
  'unlock.walletConnet.getTrustWallet': '트러스트 월렛 받기',
  'unlock.walletConnet.qrCodeDesc1': '월렛커넥트 QR 코드 받기',
  'unlock.walletConnet.qrCodeDesc2': '아직 월렛커넥트를 지원하는 앱이 없습니까?',
  'unlock.walletConnet.showWalletQrCode':
    '이 화면의 QR 코드를 사용하여 모바일 지갑을 여기에 연결하십시오',
  'unlock.walletConnet.title': '권장',
  'walletConnect.clickHereToUnlock': '다른 지갑을 해제하려면 여기를 클릭하십시오',
  'walletConnect.error': '월렛커넥트 오류',
  'walletConnect.errorOccur': '월렛커넥트 오류가 발생했습니다',
  'walletConnect.pleaseEnsureOpenWorking': '앱이 열려있고 작동하는지 확인하십시오.',
  'walletConnect.pleaseUseAWalletConnect':
    '위의 QR 코드를 스캔하려면 월렛커넥트를 지원하는 앱을 사용하십시오',
  'walletConnect.qrCode': '월렛커넥트 QR 코드',
  'walletConnect.readyToConfirm': '확인하십시오',
  'walletConnect.readyToConfirmBody': '지갑 앱에서 거래를 확인하십시오.',
  'walletconnect.notifycation.connectAgain': '다시 연결',
  'walletconnect.notifycation.disconnectMessage': ' 모바일 지갑에서 연결이 끊어졌습니다...',
  'walletconnect.notifycation.hide': '숨기기',
  'local.secure.storage': 'Local Secure Storage',
  'local.keystore.replace.tips':
    'You already have a keystore file, make sure you have backed up before replace',
}
